import * as R from 'ramda';
import { createSelector } from 'reselect';
import { convertToOptions } from './helpers';
///////////////////////////////////////////////////////////////

const selectIntStore = (state) => state.intl;

const makeSelectIntl = () => createSelector(
  selectIntStore,
  ({ intlSettings }) => R.or(intlSettings, []),
);

const makeSelectChangedLocaleItems = () => createSelector(
  selectIntStore,
  ({ changedLocaleItems }) => R.or(changedLocaleItems, []),
);

const makeSelectCustomKeys = () => createSelector(
  selectIntStore,
  ({ customKeys }) => customKeys,
);

const makeSelectActiveTab = () => createSelector(
  selectIntStore,
  ({ activeTab }) => activeTab,
);

const makeSelectActiveBranchName = () => createSelector(
  selectIntStore,
  ({ branchName }) => branchName,
);

const makeSelectActivePageTab = () => createSelector(
  selectIntStore,
  ({ pageTab }) => pageTab,
);

const makeSelectTabInfo = () => createSelector(
  selectIntStore,
  ({ tabs }) => R.or(tabs, []),
);

const makeSelectLanguage = () => createSelector(
  selectIntStore,
  ({ languageTitle }) => R.or(languageTitle, {}),
);

const makeSelectMastersBranchList = () => createSelector(
  selectIntStore,
  ({ masterBranchList }) => convertToOptions(masterBranchList),
);

const makeSelectCurrentLanguage = () => createSelector(
  selectIntStore,
  ({ listLanguageFromBack }) => R.or(listLanguageFromBack, []),
);

export {
  makeSelectIntl,
  selectIntStore,
  makeSelectTabInfo,
  makeSelectLanguage,
  makeSelectActiveTab,
  makeSelectCustomKeys,
  makeSelectActivePageTab,
  makeSelectCurrentLanguage,
  makeSelectActiveBranchName,
  makeSelectMastersBranchList,
  makeSelectChangedLocaleItems,
};
